import { AfterViewInit, ContentChildren, Directive, Input, QueryList, Renderer2 } from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: 'mat-form-field',
})
export class MatSelectOnlyChildDirective implements AfterViewInit {
  @ContentChildren(MatSelect) selects!: QueryList<MatSelect>;

  @Input()
  get matSelectOnlyChildDisabled(): boolean {
    return this._matSelectOnlyChildDisabled;
  }
  set matSelectOnlyChildDisabled(value: BooleanInput) {
    this._matSelectOnlyChildDisabled = coerceBooleanProperty(value);
  }
  private _matSelectOnlyChildDisabled = false;

  constructor(private formField: MatFormField, private renderer: Renderer2) { }

  ngAfterViewInit() {
    const matSelect = this.selects.first;

    if (matSelect) {
      this.update(matSelect);

      matSelect.options.changes.pipe(untilDestroyed(this)).subscribe(() => this.update(matSelect));
      matSelect.valueChange.pipe(untilDestroyed(this)).subscribe(() => this.update(matSelect));
      matSelect.optionSelectionChanges.pipe(untilDestroyed(this)).subscribe(() => this.update(matSelect));
    }
  }

  private update(matSelect: MatSelect) {
    if (this.matSelectOnlyChildDisabled) {
      this.renderer.removeClass(this.formField._elementRef.nativeElement, 'mat-form-field-disabled');
      return;
    }

    const hasSingleOption = matSelect.options.length === 1;
    const isOptionSelected = matSelect.options.some(option => option.selected);

    if (hasSingleOption && isOptionSelected) {
      this.renderer.addClass(this.formField._elementRef.nativeElement, 'mat-form-field-disabled');
    } else {
      this.renderer.removeClass(this.formField._elementRef.nativeElement, 'mat-form-field-disabled');
    }
  }
}
